/*
 * Panorama Studios
 */

// Disable inital GMap3 loading
$.gmap3(false);


$(document).ready(function () {

	// Responsive menu
	$('header').each(function () {
		var element = $(this);
		var responsiveNav = $('.header__container');
		var toggler = $('<div class="toggler toggler--closed"><span>toggler</span></div>').click(function () {
			responsiveNav.toggleClass('collapsed');
			toggler.toggleClass('toggler--closed');
			$(document.body).toggleClass('nav-open');
		}).appendTo(element);
	});

	// Header affix
	$('header').each(function () {
		var element = $(this);
		var headroom = element.headroom();
		if (element.hasClass('headroom'))
		{
			$(document.body).addClass('headroom--enabled');
		}
	});

	// Open sub menu on touch or in responsive menu
	$('header .sub').each(function () {
		var element = $(this),
			a = element.find('> a');

		a.on("touchend", function (e) {
			if (!element.hasClass('open')) {
				element.addClass('open');
				e.preventDefault();
			}
		});
	});

	// Slideshows
	$('.slideshow--text').each(function () {
		var element = $(this);
		var cssClass = element.attr('class');
		if (element.children('.slide').length > 1) {
			element.lightSlider({
				slideMargin: 0,
				mode: 'fade',
				loop: true,
				auto: true,
				speed: 1000,
				pause: 3000,
				pager: false,
				controls: false,
				addClass: cssClass,
				item: 1,
				adaptiveHeight: true
			});
		}
	});

	$('.slideshow--image').each(function () {
		var element = $(this);
		var cssClass = element.attr('class');
		if (element.children('li').length > 1) {
			element.lightSlider({
				slideMargin: 0,
				mode: 'fade',
				loop: true,
				auto: true,
				speed: 1000,
				pause: 7000,
				pager: true,
				controls: false,
				addClass: cssClass,
				item: 1
			});
		}
	});

	// Slider
	$('.slider--offers').each(function () {
		var element = $(this),
			cssClass = element.attr('class');

		if (element.children('.slide').length > 1) {
			element.lightSlider({
				slideMargin: 0,
				loop: true,
				auto: true,
				speed: 1000,
				pause: 4000,
				pager: false,
				item: 3,
				slideMove: 0,
				addClass: cssClass,
				responsive: [
					{
						breakpoint: 1280,
						settings: {
							item: 2,
							slideMove: 1
						}
					}, {
						breakpoint: 768,
						settings: {
							item: 1,
							slideMove: 1
						}
					}
				]
			});
		}
	});

	// Slider
	$('.slider--categories, .slider--products').each(function () {
		var element = $(this),
			cssClass = element.attr('class');

		if (element.children('.slide, .slide--product').length > 1) {
			element.lightSlider({
				slideMargin: 0,
				loop: true,
				auto: true,
				speed: 1000,
				pause: 4000,
				pager: false,
				controls: true,
				item: 5,
				slideMove: 1,
				addClass: cssClass,
				responsive: [
					{
						breakpoint: 1920,
						settings: {
							item: 4,
							slideMove: 1
						}
					}, {
						breakpoint: 1280,
						settings: {
							item: 3,
							slideMove: 1
						}
					}, {
						breakpoint: 768,
						settings: {
							item: 2,
							slideMove: 1
						}
					}, {
						breakpoint: 425,
						settings: {
							item: 1,
							slideMove: 1
						}
					}
				]
			});
		}
	});

	// Grid
	$('.offers').masonry({
		itemSelector: '.offer',
		columnWidth: '.offer'
	});
	
	// Lightbox
	$('#container').lightGallery({
		selector: '.lightbox',
		download: false,
		thumbnail: false,
		fullScreen: false
	});

	// Contact box
	$('.contact-box').each(function () {
		var element = $(this);

		element.on("touchend", function (e) {
			element.toggleClass('open');
		});
	});

	// Smooth scroll
	$('a[href^="#"]').click(function () {
		var target = $(this.hash);
		if (!target.length) {
			target: $('[name=' + this.hash.slice(1) + ']');
		}
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top - 120
			}, 500);

			return false;
		}
	});

	// Add scroll to
	$("<a class=\"scroll-to scroll-to--top\">top</a>").appendTo('footer');

	// Scrol to top
	$('.scroll-to--top').click(function () {
		$('html,body').animate({
			scrollTop: 0
		}, 500);
	});
	
	if ($('.band--breadcrumb').length) {
		$('<a class=\"scroll-to scroll-to--content scroll-to--light\">content</a>').appendTo('#content');

	}
	else {
		$('<a class=\"scroll-to scroll-to--content\">content</a>').appendTo('#content');
	}

	$(".scroll-to--content").click(function () {
		$('html, body').animate({
			scrollTop: $("#content").offset().top - $('header').height()
		}, 500);
	});

	// Route form
	$('.form--route').each(function () {
		var element = $(this);
		var button = element.find('.button');
		var destinationAddress = element.find('input[type=text]');
		var destination = button.attr('data-address');

		button.click(function (e) {
			var route = {
				saddr: destinationAddress.val(),
				daddr: destination
			};

			window.open('https://maps.google.nl/?' + $.param(route), '_blank');

			e.preventDefault();
		});
	});

	// Change target for external sites
	var getDomainName = function (hostName) {
		return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1);
	};
	$('a:not([target])').filter(function () {
		var link = $(this);

		if (link.filter('[rel~="external"]').length) return true; // Link rel attribute contains 'external'

		var href = link.attr('href');
		if (new RegExp('\.pdf$', 'i').test(href)) return true; // Link to PDF file

		if (new RegExp('^https?://', 'i').test(href)) {
			var linkHostName = getDomainName(href.substring(href.indexOf('/') + 2, href.indexOf('/', 8)));
			if (!new RegExp('(^|\.)' + getDomainName(document.location.hostname) + '$', 'i').test(linkHostName)) {
				// Link is to different domain name
				return true;
			}
		}

		return false;
	}).attr('target', '_blank');

	// Google Maps
	var maps = $('.google-maps');
	if (maps.length) {
		// Load Google Maps API once
		$.ajaxSetup({
			cache: true
		});
		// Load the script and add the api key
		$.getScript('https://maps.google.com/maps/api/js?sensor=false' + (aspJsVars['MapsApiKey'] ? '&key=' + aspJsVars['MapsApiKey'] : ''), function () {
			maps.each(function () {
				// Create map
				var map = $(this).addClass('activated');
				// Split the markers
				var markers = map.children('img')[0].src.split('&markers=');
				// Remove the first item as it is google maps options
				var unformatedValues = markers.shift();
				// Convert values to JSON Markup
				var values = JSON.parse('{"' + decodeURI(unformatedValues.split('?')[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
				// Convert the markers for gmap use
				jQuery.each(markers, function (i, val) { splitedVar = val.split(/%7C/g); markers[i] = { position: new google.maps.LatLng(splitedVar[splitedVar.length - 1].split('%2c')[0], splitedVar[splitedVar.length - 1].split('%2c')[1]), options: { icon: { url: (window.baseUrl || '/') + "images/marker-sprite.png", anchor: new google.maps.Point(68, 135), scaledSize: new google.maps.Size(136, 146) } } } });
				// Render the google maps
				map.gmap3({
					center: new google.maps.LatLng(values.center.split('%2c')[0], values.center.split('%2c')[1]),
					zoom: parseInt(values.zoom),
					disableDefaultUI: true,
					minZoom: 4,
					maxZoom: 17,
					draggable: !("ontouchend" in document),
					mapTypeControlOptions: {
						style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
					},
					scrollwheel: false,
					zoomControl: true,
					zoomControlOptions: {
						position: 4,
						style: 0
					}
				})
				// Add the markers
				.marker(markers)
				//.fit();
			});
		});
	}
});